import React, {Component} from "react";
import {
    Backdrop, Box,
    CircularProgress, Typography
} from "@mui/material";
import queryString from "query-string";

import agent from "../../../../agent/agent";
import {
    Filter as FilterComponent,
    Table as TableComponent
} from "./components";

const initialFilter = {
    "sortInfo": "-id",
};

const visibleColumns = [
    {
        id: "id",
        label: "№",
        sortable: true,
        width: 'auto',
    },
    {
        id: "deliveryDate",
        label: "Срок доставки",
        sortable: true,
        width: 'auto',
    },
    {
        id: "orderItems",
        label: "Груз (наименование товара)",
        sortable: false,
        width: 'auto',
    },
    {
        id: "storeAddress",
        label: "Адрес отправки",
        sortable: false,
        width: 'auto',
    },
    {
        id: "deliveryAddress",
        label: "Адрес доставки",
        sortable: false,
        width: 'auto',
    },
    {
        id: "finalDeliveryPrice",
        label: "Стоимость доставки",
        sortable: false,
        width: 'auto',
    },
];

class ListOrders extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orders: [],

            filter: {
                ...initialFilter
            },
            pagination: {
                page: 1,
                totalPage: 1
            },

            settings: {},

            isLoading: true,
            isShowBackdrop: false,
        };

        this.refPopUpDetailProduct = React.createRef();
        this.refDialogConfirmation = React.createRef();
    }

    componentDidMount = async () => {
        await this.initFilter();
        await this.getSettings();
        await this.getOrders();
    }
    initFilter = async () => {
        const locationSearch = this.props?.location?.search || "";
        let parseSearch = queryString.parse(locationSearch, {
            arrayFormat: "bracket"
        });
        const page = parseSearch.page || 1;

        delete parseSearch.page;

        let filter = {
            ...initialFilter,
            ...parseSearch
        };
        let pagination = {
            ...this.state.pagination,
            page: page
        };

        await this.setState({
            filter,
            pagination,

            initOpenFilter: Object.keys(parseSearch || {}).length > 0
        });
    }


    // Логика получения заказов
    getOrders = async () => {
        this.setState({isLoading: true});

        const filter = this.getFilters();
        const {
            orders,
            totalCount
        } = await agent.get(`/orders${filter}&limit=20&listing=true`).then((res) => {
            return {
                orders: res.data.orders || [],
                totalCount: res.data.count
            }
        }).catch((err) => {
            return {
                orders: [],
                totalCount: 0
            }
        });


        let pagination = {...this.state.pagination};
        pagination.totalPage = Math.ceil(totalCount / 20) || 1;

        this.setState({
            isLoading: false,
            pagination,
            orders
        });
    }

    getSettings = async () => {
        const settings = await agent.get(`/settings`)
            .then((res) => res.data.settings)
            .catch((err) => {
            });

        this.setState({settings});
    }


    // Логика работы с фильтром
    getFilters = () => {
        const filter = {...this.state.filter};
        const pagination = {...this.state.pagination};

        let string = [
            `page=${pagination.page}`
        ];
        Object.keys(filter).map((key) => {
            if (filter[key]) {
                let value = filter[key];

                string.push(`${key}=${value}`);
            }
        });

        window.history.replaceState(null, null, `/list?${string.join("&")}`);

        return `?${string.join("&")}`
    }
    changeFilter = async (filter, isFastStart) => {
        await this.setState({filter})
        if (!isFastStart) {
            return null;
        }

        await this.getOrders();
    }
    changePagination = async (pagination) => {
        await this.setState({pagination});
        await this.getOrders();
    }
    resetFilter = async () => {
        await this.setState({filter: {...initialFilter}});
        await this.getOrders();
    }


    _routeOrder = (order) => {
        this.props.history.push(`/list/${order.id}`);
    }

    render() {
        const {
            orders,

            filter,
            pagination,

            settings,

            isLoading,
            isShowBackdrop
        } = this.state;

        return (
            <>

                <Box mb={4}>
                    <Typography variant="h1" textAlign="left">Лента заказов</Typography>
                </Box>


                <FilterComponent
                    filter={filter}
                />

                <TableComponent
                    data={orders}
                    filter={filter}
                    pagination={pagination}
                    settings={settings}
                    visibleColumns={visibleColumns}

                    isLoading={isLoading}

                    onChangePagination={this.changePagination}
                    onChangeFilter={this.changeFilter}


                    routeOrder={this._routeOrder}
                />

                <Backdrop open={isShowBackdrop}>
                    <CircularProgress color="inherit"/>
                </Backdrop>

            </>
        );
    }
}

export default ListOrders